import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Scanline } from './Scanline';
import { HistoryIcon, PhoneOutgoingIcon, PercentIcon, FolderCheckIcon, MessageCircleWarningIcon } from 'lucide-react';
const useCases = [{
  icon: HistoryIcon,
  title: 'Pick up where you left off',
  description: "A borrower calls back after six weeks. Open their profile and skim the timeline — you're back up to speed before you say hello."
}, {
  icon: PhoneOutgoingIcon,
  title: 'Prep before a follow-up',
  description: "Ask the assistant what was discussed, what you promised, and what's outstanding — a two-minute brief before every call."
}, {
  icon: PercentIcon,
  title: 'Recall promised rates & terms',
  description: 'Quoted a rate three calls ago? Pull the exact number and the exact words, backed by the source transcript.'
}, {
  icon: FolderCheckIcon,
  title: 'Track outstanding documents',
  description: 'Know exactly which pay stubs, W-2s, and statements you requested from each borrower — and which are still missing.'
}, {
  icon: MessageCircleWarningIcon,
  title: 'Handle objections consistently',
  description: 'See every concern a borrower has raised across calls, so you address them head-on instead of being surprised twice.'
}];
export function UseCases() {
  return <section id="use-cases" className="relative scroll-mt-16 border-t border-slate-100 texture-dots py-20 lg:py-28" data-id="element-381">
      <Scanline data-id="element-382" />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-383">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="mx-auto max-w-2xl text-center" data-id="element-384">
          <p className="font-mono-brand text-xs uppercase tracking-[0.2em] text-teal-600" data-id="element-385">
            // use_cases
          </p>
          <h2 className="font-display mt-4 text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl" data-id="element-386">
            Where borrower memory pays off
          </h2>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-387">
          {useCases.map((uc, i) => <motion.div key={uc.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-388">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg border border-teal-600/30 bg-teal-50" data-id="element-389">
                <uc.icon className="h-5 w-5 text-teal-600" aria-hidden="true" data-id="element-390" />
              </span>
              <h3 className="font-display mt-4 text-base font-bold text-slate-900" data-id="element-391">
                {uc.title}
              </h3>
              <p className="mt-2 text-sm leading-6 text-slate-600" data-id="element-392">
                {uc.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}